module.exports = __webpack_public_path__ + "media/customizations/reverie/back-2ac729c114d2a03313d9348d659bb661.jpg";